import { MiniMap } from '@xyflow/react'

/**
 * GraphMiniMap — the graph editors' navigator.
 *
 * The part of the graph in view is an OUTLINE, nothing else, on the panel's
 * own background: no fill over the rest (React Flow's defaults paint the panel
 * white and wash the area outside the view in a light mask).
 *
 * Dragging in it moves the view directly (React Flow's own `pannable`); the
 * wheel zooms. 1.5x React Flow's default 200x150 so it is usable as a
 * navigator.
 */
export const MINIMAP_WIDTH = 300
export const MINIMAP_HEIGHT = 225

export function GraphMiniMap({ style, nodeColor }) {
  return (
    <MiniMap
      pannable
      zoomable
      // React Flow paints the panel from its own --xy-minimap-background-color
      // (white by default) and ignores a `background` in style; bgColor is
      // the prop that reaches it.
      bgColor={style?.background ?? 'var(--m-panel)'}
      maskColor="transparent"
      maskStrokeColor="var(--m-accent)"
      maskStrokeWidth={1.5}
      style={{ width: MINIMAP_WIDTH, height: MINIMAP_HEIGHT, ...style }}
      nodeColor={nodeColor}
    />
  )
}
